import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import logError from 'src/utils/logError';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment;
}

const ActivityLogTaskFlagResolvedInterviewDeclined: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;

  // eslint-disable-next-line no-underscore-dangle
  if (details?.__typename !== 'ActivityLogTaskInterviewerDetails') {
    logError('ActivityLogTaskFlagResolvedInterviewDeclined: details is not ActivityLogTaskInterviewerDetails');
    return null;
  }

  const { interviewName, interviewer } = details;

  const { fullName } = interviewer;

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.resolvedInterviewerDecline"
      actionLabelValues={{ name: fullName, interviewName }}
    />
  );
};

ActivityLogTaskFlagResolvedInterviewDeclined.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskFlagResolvedInterviewDeclined_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogTaskInterviewerDetails {
          __typename

          interviewName
          interviewer {
            id
            fullName
          }
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskFlagResolvedInterviewDeclined;
